import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=08cb7be3&"
import script from "./taskList.vue?vue&type=script&lang=js&"
export * from "./taskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports